module.exports = __webpack_public_path__ + "static/media/cedula.a34e78b7.png";